import { useUrlSearchParams } from '@vueuse/core';

import {
  reactive,
  watch,
} from 'vue';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export default (param: string, defaults: Record<string, any> = {}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const encode = (data: Record<string, any>): string => {
    try {
      const json = JSON.stringify(data);

      return btoa(json);
    } catch (error) {
      console.error(`Failed to encode parameter "${param}":`, error);

      return '';
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const decode = (base64: string | string[] | undefined): Record<string, any> => {
    if (typeof base64 !== 'string') {
      return { ...defaults };
    }

    try {
      const json = atob(base64);

      const data = JSON.parse(json);

      return { ...defaults, ...data };
    } catch (error) {
      console.error(`Failed to decode parameter "${param}":`, error);

      return { ...defaults };
    }
  };

  const params = useUrlSearchParams('hash-params');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data = reactive<Record<string, any>>({ ...decode(params[param]) });

  watch(
    () => ({ ...data }),
    (newValue) => {
      Object.keys(newValue).forEach((key) => {
        if (newValue[key] === null || newValue[key] === undefined) {
          /* eslint-disable-next-line no-param-reassign */
          delete newValue[key];
        }
      });

      const base64 = encode(newValue);

      if (base64) {
        params[param] = base64;
      }
    },
    { deep: true },
  );

  return data;
};
